/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_OfInputs */

const en_common_of = /** @type {(inputs: Common_OfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Of`)
};

/**
* | output |
* | --- |
* | "Of" |
*
* @param {Common_OfInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const common_of = /** @type {((inputs?: Common_OfInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_OfInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_common_of(inputs)
});